require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/fn/object/keys.js
// module id = 1990
// module chunks = 2